import { render, staticRenderFns } from "./zhengcexinxi.vue?vue&type=template&id=79b3c2ea&scoped=true&"
import script from "./zhengcexinxi.vue?vue&type=script&lang=js&"
export * from "./zhengcexinxi.vue?vue&type=script&lang=js&"
import style0 from "./zhengcexinxi.vue?vue&type=style&index=0&id=79b3c2ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b3c2ea",
  null
  
)

export default component.exports